import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { PharmacyJSONAModel } from "interfaces/jsona-models/PharmacyJSONAModel";

export class PharmacySelector extends BaseApiSelector<PharmacyJSONAModel> {
  constructor() {
    super(ResourceType.Pharmacy);
  }
}
